import { Badge, BadgeSizes, TableCellTypes } from '@carboledger/ui';
import { CellText, makeSerialCell } from '@/components/common';
import { MB_PERIOD_STATUS_TONE } from '@/config/statusTones';
import { SITE_MB_PERIOD_COLUMNS } from './sites.constants';

const renderStatus = (ctx) => {
  const { status, statusLabel } = ctx.row;
  if (!statusLabel) return <CellText>-</CellText>;

  return (
    <Badge variant={MB_PERIOD_STATUS_TONE[status]} size={BadgeSizes.sm} withDot>
      {statusLabel}
    </Badge>
  );
};

export const buildSiteMbPeriodColumns = (t) => [
  {
    id: SITE_MB_PERIOD_COLUMNS.serialNo,
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.custom,
    width: 80,
    cell: makeSerialCell(),
  },
  {
    id: SITE_MB_PERIOD_COLUMNS.periodName,
    header: t('FIELD_PERIOD_NAME'),
    type: TableCellTypes.text,
    width: 160,
    pinnable: true,
  },
  {
    id: SITE_MB_PERIOD_COLUMNS.timePeriod,
    header: t('FIELD_TIME_PERIOD'),
    type: TableCellTypes.text,
    width: 220,
  },
  {
    id: SITE_MB_PERIOD_COLUMNS.status,
    header: t('FIELD_STATUS'),
    type: TableCellTypes.custom,
    width: 140,
    cell: renderStatus,
  },
  {
    id: SITE_MB_PERIOD_COLUMNS.startDate,
    header: t('FIELD_PERIOD_START_DATE'),
    type: TableCellTypes.text,
    width: 170,
  },
  {
    id: SITE_MB_PERIOD_COLUMNS.endDate,
    header: t('FIELD_PERIOD_END_DATE'),
    type: TableCellTypes.text,
    width: 170,
  },
];
